import React from 'react';
import { Helmet } from 'react-helmet-async';
import seoConfig from '../config/seoConfig';

function LocalBusinessSchema() {
  const { 
    businessName, 
    businessDescription, 
    businessAddress, 
    businessPhone, 
    businessEmail, 
    businessHours,
    siteUrl,
    socialProfiles 
  } = seoConfig;

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: businessName,
    description: businessDescription,
    url: siteUrl,
    telephone: businessPhone,
    email: businessEmail,
    address: {
      '@type': 'PostalAddress',
      streetAddress: businessAddress.street,
      addressLocality: businessAddress.city,
      addressRegion: businessAddress.region,
      postalCode: businessAddress.postalCode,
      addressCountry: businessAddress.country
    },
    openingHours: businessHours.map(h => `${h.day} ${h.hours}`),
    sameAs: Object.values(socialProfiles),
    priceRange: '$$',
    image: `${siteUrl}/images/og-image.jpg`,
    hasMap: `https://maps.google.com/?q=${encodeURIComponent(
      `${businessAddress.street}, ${businessAddress.city}, ${businessAddress.country}`
    )}`
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
}

export default LocalBusinessSchema;